module.exports = __webpack_public_path__ + "img/chinesecompany108.f47927b2.png";